export default __webpack_public_path__ + "static/814-da729ccaf74443b7f668ee2d15908ec4.gif";